/* eslint-disable sort-keys */
export const navigationWrapper = {
    'backgroundColor': '$questionnaireNavigation',
    'borderColor': '$questionnaireNavigationBorder',
    'borderWidth': 0,
    'borderStyle': '$questionnaireNavigation',
    'boxSizing': 'border-box',
    'padding': '20px',
    'display': 'flex',
    'width': '100%',
    'justifyContent': 'center',
    '> div': {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        maxWidth: '$questionnaireNavigation',
        width: '100%',
    },
    'variants': {
        isWrapped: {
            true: {
                '> div': {
                    '> *': {
                        'width': '100%',
                        '> *': {width: '100%'},
                    },
                },
            },
        },
        isSingle: {true: {'> div': {justifyContent: 'center'}}},
        position: {
            top: {borderBottomWidth: '$questionnaireNavigation'},
            bottom: {borderTopWidth: '$questionnaireNavigation'},
        },
    },
}
